<template>
  <OcrTableWrap :title="title">
    <v-table v-if="columns.length" class="well-table sample-table well-table-data fd-table">
      <thead>
        <tr class="main-header">
          <th v-for="col in columns" :key="col">{{ col }}</th>
        </tr>
      </thead>
      <tbody class="well-table-content">
        <tr v-for="(row, idx) in rows" :key="idx">
          <td v-for="col in columns" :key="col + idx">
            <span class="ocr-table-cell">{{ displayCell(row[col]) }}</span>
          </td>
        </tr>
      </tbody>
    </v-table>
    <p v-else class="ocr-empty-cell ocr-empty-cell--padded">No table data</p>
  </OcrTableWrap>
</template>

<script>
import OcrTableWrap from "@/components/layout/OCR/OcrTableWrap.vue";

export default {
  name: "OcrDataTable",
  components: { OcrTableWrap },
  props: {
    rows: { type: Array, default: () => [] },
    title: { type: String, default: "" },
  },
  computed: {
    columns() {
      if (!this.rows.length) return [];
      return Object.keys(this.rows[0]);
    },
  },
  methods: {
    displayCell(value) {
      if (value == null || value === "") return "—";
      return value;
    },
  },
};
</script>
